<template>
  <SbTag
    v-if="itemHasValue"
    class="sb-multiselect-inner__tag"
    :label="getLabel"
    :closable="!isDisabled"
    :data-testid="`${dataTestid}-tag`"
    :avatar="getAvatar"
    @keydown="$emit('keydown', $event, item)"
    @close="$emit('close', $event, item)"
  />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import SbTag from '../../Tag'
import type { Option } from '../types'

export default {
  name: 'SelectInnerTag',

  components: {
    SbTag,
  },

  props: {
    item: {
      type: Object as PropType<Option>,
      default: () => ({}),
    },
    itemLabel: {
      type: String,
      default: 'label',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    showTagAvatars: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['keydown', 'close', 'click'],

  computed: {
    dataTestid() {
      return this.$attrs['data-testid'] || 'sb-multiselect-inner'
    },
    getLabel(): string {
      const label = this.item[this.itemLabel]
      return label ? label.toString() : ''
    },
    getAvatar() {
      if (!this.showTagAvatars) {
        return undefined
      }

      const avatarKey = this.item.src ? 'src' : 'avatar'
      const label = this.item[this.itemLabel]?.toString() || ''
      return {
        alt: label,
        friendly_name: label,
        image_url: this.item[avatarKey]?.toString() || '',
      }
    },

    itemHasValue() {
      return Object.keys(this.item).length > 0
    },
  },
}
</script>
